/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wizard_Step_CopyInputs */

const en_wizard_step_copy = /** @type {(inputs: Wizard_Step_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy prompt`)
};

const id_wizard_step_copy = /** @type {(inputs: Wizard_Step_CopyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salin prompt`)
};

/**
* | output |
* | --- |
* | "Copy prompt" |
*
* @param {Wizard_Step_CopyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const wizard_step_copy = /** @type {((inputs?: Wizard_Step_CopyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wizard_Step_CopyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_wizard_step_copy(inputs)
	return en_wizard_step_copy(inputs)
});